import React, { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import moment from 'moment';
import Select from "react-select";
import { v4 as uuidv4 } from 'uuid';
import Cookies from "universal-cookie";
import { DayPicker } from 'react-day-picker';
import { toast, Bounce } from 'react-toastify';
import { Modal, Popover, TimePicker, Space } from 'antd';
import { Calendar as CalendarIcon, MapPinCheck, X } from "lucide-react";

import "./modal.css";
import 'antd/dist/reset.css';
import "react-day-picker/style.css";

import config from '../web3/web3Config.json';

import SlotCalendar from "../components/SlotCalendar.js";
import RepeatEvent from "../components/createRepeatEvent.js";

import { encrypt } from "../helper/web3helper.js";
import { CompleteLoader } from './common-alert.js';
import { sendInvite } from '../helper/emailHelper.js';
import { fetchLocation } from '../helper/commonHelper.js';
import { calender_svg } from "../assets/svg/calender_svg.js";
import { getSuggestion } from '../helper/contract-helper.js';
import { transactionAction } from '../helper/chain-helper.js';
import { getCalendarContract } from '../helper/contract-helper.js';
import { generateRecurrenceRule } from "../helper/inviteHelper.js";
import { convertToTimeZone, formatToMMDDYYYY } from "../helper/eventHelper.js";
import { createGoogleMeetEvent, createZoomMeeting, meetAppsStatus } from "../service/api-actions.js";
import { reportError, toErrorString } from "../utils/errorLogger.js";

const cookies = new Cookies();
const userName = localStorage.getItem('UserName');
export const CreateEvent = (params) => {

    const [guestText, setGuestText] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [text, setText] = useState("")
    const [emailSuggestions, setEmailSuggestions] = useState([]);
    const [guestList, setGuestList] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [inputLocationValue, setInputLocationValue] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [locations, setLocations] = useState([]);
    const [loader, setLoader] = useState(false);
    const [activeField, setActiveField] = useState(null);
    const [popoverVisibleFrom, setPopoverVisibleFrom] = useState(false);
    const [popoverVisibleTo, setPopoverVisibleTo] = useState(false);
    const [selectedDate, setSelectedDate] = useState(moment(new Date()).startOf('day'));
    const [toDate, setToDate] = useState(moment(new Date()).startOf('day'));
    const user = cookies.get("userObject");
    const [fromTime, setFromTime] = useState('12:00 AM');
    const [toTime, setToTime] = useState('12:00 AM');
    const [isCheck, setChecked] = useState(false);
    const [visible, setVisible] = useState(false);
    const [buttonvisible, setButtonvisible] = useState(true);
    const timePickerRef = useRef(null);
    const timePicker = useRef(null);
    const [repeat, setRepeat] = useState('');
    const [customRepeat, setCustomRepeat] = useState('');
    const token = cookies.get("accessToken") || localStorage.getItem("accessToken");
    const [zoomMeetingDetails, setZoomMeetingDetails] = useState(null);
    const [meetingAppConnectStatus, setMeetingAppConnectStatus] = useState('')

    const [selectedConferencing, setSelectedConferencing] = useState(null);
    const [statusCheckInterval, setStatusCheckInterval] = useState(null);

    useEffect(() => {
        const getSug = async () => {
            const filteredAddressBook = await getSuggestion();
            const meetingAppConnectStatus = await meetAppsStatus();
            setEmailSuggestions(filteredAddressBook);
            if (meetingAppConnectStatus?.data) {
                setMeetingAppConnectStatus(meetingAppConnectStatus?.data)
            } else {
                setMeetingAppConnectStatus('');
            }
        }
        setEmpty();
        getSug();
    }, [params])

    // Cleanup interval on component unmount
    useEffect(() => {
        return () => {
            if (statusCheckInterval) {
                clearInterval(statusCheckInterval);
            }
        };
    }, [statusCheckInterval]);

    // Function to start checking meeting app status
    const startStatusCheck = (meetingType) => {
        // Clear any existing interval
        if (statusCheckInterval) {
            clearInterval(statusCheckInterval);
        }

        // Start checking every 5 seconds
        const interval = setInterval(async () => {
            try {
                const response = await meetAppsStatus();
                if (response?.data) {
                    const newStatus = response.data;
                    setMeetingAppConnectStatus(newStatus);

                    // Check if the selected meeting type is now connected
                    if (meetingType === 'zoom' && newStatus.isZoomConnected) {
                        clearInterval(interval);
                        setStatusCheckInterval(null);
                        // Auto-select the now-connected Zoom option
                        setSelectedConferencing({
                            value: 'zoom',
                            label: 'Zoom',
                            icon: <img src="/app/zoom.svg" alt="Zoom" width={18} />
                        });
                    } else if (meetingType === 'google' && newStatus.isGoogleConnected) {
                        clearInterval(interval);
                        setStatusCheckInterval(null);
                        // Auto-select the now-connected Google Meet option
                        setSelectedConferencing({
                            value: 'google',
                            label: 'Google Meet',
                            icon: <img src="/app/google-meet.png" alt="Google Meet" width={25} />
                        });
                    }
                }
            } catch (error) {
                const errorStr = toErrorString(error || error.message);
                reportError({
                    endpoint: '/calendarIntgrationStatus',
                    message: `FileName: createEvents.js, Fun: startStatusCheck, ${String(error.message || 'Unhandled error')}`,
                    error: errorStr,
                    userName: userName || '',
                });
                console.error('Error checking meeting app status:', error);
            }
        }, 5000); // Check every 5 seconds

        setStatusCheckInterval(interval);
    };

    // Function to stop status checking
    const stopStatusCheck = () => {
        if (statusCheckInterval) {
            clearInterval(statusCheckInterval);
            setStatusCheckInterval(null);
        }
    };

    const setEmpty = () => {
        setSuggestions([]);
        setEmailSuggestions([]);
        setGuestList([]);
        setGuestText('');
        setDescription('');
        setTitle('');
        setVisible(false);
        setToTime('12:00 AM');
        setFromTime('12:00 AM');
        setSelectedDate(moment(new Date()).startOf('day'));
        setToDate(moment(new Date()).startOf('day'));
        setSelectedConferencing(null);
        stopStatusCheck(); // Stop any ongoing status checks
    }

    const handleGuest = (data) => {
        if (!guestList.includes(data)) {
            setGuestList([...guestList, data]);
        }
        setGuestText('');
        setSuggestions([]);
    }

    const createEvent = async () => {
        try {
            if (!title.trim()) {
                toast.error('Title is required', {
                    position: "top-center",
                    transition: Bounce,
                })
                return;
            }
            setLoader(true);
            setText("Please wait, your event is being stored on the blockchain, Going forward it will be fast.")
            const UniqueId = uuidv4();
            let list = [];
            if (selectedLocation && selectedLocation.label && selectedLocation.label.trim()) {
                list.push({
                    key: 'location',
                    value: selectedLocation.label.trim()
                })
            }
            if (guestList.length > 0) {
                guestList.map((email) => {
                    list.push({
                        key: 'guest',
                        value: email
                    })
                })
            }
            if (repeat) {
                list.push(
                    {
                        key: 'repeatEvent',
                        value: repeat
                    }
                )
            }
            if (customRepeat) {
                list.push(
                    {
                        key: 'customRepeatEvent',
                        value: customRepeat
                    }
                )
            }
            let selectedTimezone = localStorage.getItem('timeZone');
            const { formattedFrom, formattedTo } = convertToTimeZone(selectedDate, toDate, fromTime, toTime, selectedTimezone);
            let updatedDescriptions = description;
            if ((selectedConferencing?.value === 'google' || selectedConferencing?.value === 'zoom')) {
                const result = await generateMeetingLink(title, description, selectedDate, toDate, fromTime, toTime, list);
                if (result) {
                    let updatedList = list.filter(item => item.key !== 'location');
                    updatedList.push({ key: 'meetingEventId', value: result?.meetingDetails?.id });
                    updatedList.push({ key: 'location', value: result?.meetingDetails?.hangoutLink || result?.meetingDetails?.join_url });
                    updatedList.push({ key: 'locationType', value: selectedConferencing?.value })
                    list = updatedList;
                    updatedDescriptions = result?.description;
                }
            }

            const eventParams = {
                uid: UniqueId.toString(),
                title,
                description: updatedDescriptions || "",
                fromTime: formattedFrom || "",
                toTime: formattedTo || "",
                done: false,
                list
            };
            const inputContact = {
                contact: eventParams
                    .list
                    .filter((event) => event.key === "guest")
                    .map((event) => ({ key: "contact", value: event.value }))
            };
            const contractInstance = getCalendarContract();
            const encryptionValue = await encrypt([eventParams], token, []);
            const eventParamsValue = {
                uuid: encryptionValue?.data?.encryptedData[0],
                uid: eventParams?.uid,
                title: eventParams?.title,
                fromTime: eventParams?.fromTime || "",
                toTime: eventParams?.toTime || "",
            }

            const paramsValue = [[eventParamsValue], user.name, inputContact];
            const hash = await transactionAction(contractInstance, "addEvent", paramsValue, user.wallet, "calendar")
            if (hash) {
                if (guestList.length > 0) {
                    const sentEmails = await sendInvite(guestList, eventParams, user.name, user.wallet, "You are invited to the meeting.", "Please find the details in the attachment.", []);
                    if (!sentEmails) {
                        toast.error('Faild to send the invite.', {
                            position: "top-center",
                            transition: Bounce,
                        });
                        setLoader(false);
                        setText("")
                        return;
                    }
                }
                window.dispatchEvent(new CustomEvent("NEW_EVENT_CREATED", {
                    detail: {
                        title,
                        start: formattedFrom,
                        end: formattedTo,
                        timezone: selectedTimezone || ""
                    }
                }));
                toast.success('Successfully created the event', {
                    position: "top-center",
                    transition: Bounce,
                });
                params.close();
            } else {
                toast.error('Faild to create the event.', {
                    position: "top-center",
                    transition: Bounce,
                });
                setLoader(false);
                setText("")
                return;
            }
            setLoader(false);
            setText("")
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '-',
                message: `FileName: createEvents.js, Fun: startStatusCheck, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error(error);
            toast.error('Faild to create the event.', {
                position: "top-center",
                transition: Bounce,
            });
            setLoader(false);
        } finally {
            setLoader(false);
            setText("")
        }
    }

    const handleInputChange = (inputValue) => {
        setInputLocationValue(inputValue);
        getAsyncLocations(inputValue);
    };

    const getAsyncLocations = async (inputValue) => {
        const locationValue = await fetchLocation(inputValue);
        setLocations(locationValue);
    }

    const handleLocationSelect = (selectedOption) => {
        if (selectedOption) {
            setSelectedLocation(selectedOption);
            setInputLocationValue(selectedOption.label);
        } else {
            setSelectedLocation(null);
            setInputLocationValue("");
        }
        setLocations([]);
    };

    const handledelete = (index, e) => {
        e.preventDefault();
        const updatedBulkEmail = guestList.filter((_, i) => i !== index);
        setGuestList(updatedBulkEmail);
    }

    const handleGuestInputChange = (value) => {
        const lastEmailPart = value.trim();
        setGuestText(lastEmailPart);
        const regexp =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (lastEmailPart) {
            const filterEmails = emailSuggestions.filter((email) =>
                email.toLowerCase().includes(lastEmailPart.toLowerCase()) &&
                email.toLowerCase() !== lastEmailPart.toLowerCase()
            )
            setSuggestions(filterEmails);
            const isValidEmail = regexp.test(String(lastEmailPart).toLowerCase());
            if (filterEmails.length === 0 && isValidEmail) {
                setSuggestions([lastEmailPart])
            }
        } else {
            setSuggestions([]);
        }
    }

    const handlePopoverOpen = (field) => {
        setActiveField(field);
    };

    const handleDateChange = (date) => {
        const momentDate = moment(date);
        if (activeField === "from") {
            setSelectedDate(momentDate);
            if (toDate.isBefore(momentDate, "day")) {
                setToDate(momentDate);
            }
        } else if (activeField === "to") {
            setToDate(momentDate);
        }
    };

    const disabledDates = (date) => {
        const momentDate = moment(date);
        if (activeField === "to") {
            return momentDate.isBefore(selectedDate, "day");
        }
        return false;
    };

    const handletimevisible = () => {
        setVisible(true);

    };

    const handleCheckboxChange = () => {
        if (isCheck) {
            setChecked(false);
            setButtonvisible(true)
        } else {
            setFromTime("12:00 AM")
            setToTime("12:00 AM")
            setChecked(true);
            setButtonvisible(false)
        }
    };

    const handleFromTimeChange = (time, timeString) => {
        setFromTime(timeString);
    };

    const handleToTimeChange = (time, timeString) => {
        setToTime(timeString);
    };
    useEffect(() => {
        if (!fromTime || !toTime) return;
        const timeIn24Hour = moment(fromTime, 'hh:mm A').format('HH:mm');
        const timeto24Hour = moment(toTime, 'hh:mm A').format('HH:mm');
        const formattedDate = moment(selectedDate, "MM/DD/YYYY").format("YYYY-MM-DD");
        const formattedtoDate = moment(toDate, "MM/DD/YYYY").format("YYYY-MM-DD");
        if (formattedDate === formattedtoDate) {
            if (timeIn24Hour > timeto24Hour) {
                const adjustedTime = dayjs(timeIn24Hour, 'HH:mm').add(1, 'hours').format('hh:mm A');
                setToTime(adjustedTime);
            }
        }
    }, [fromTime, toTime, selectedDate, toDate]);

    const disabledTime = (current) => {
        const fromTimeObj = dayjs(fromTime, "hh:mm A");
        const fromHour = fromTimeObj.hour();
        const fromMinute = fromTimeObj.minute();
        const formattedDate = moment(selectedDate, "MM/DD/YYYY").format("YYYY-MM-DD");
        const formattedtoDate = moment(toDate, "MM/DD/YYYY").format("YYYY-MM-DD");

        if (formattedDate === formattedtoDate) {
            return {
                disabledHours: () => {
                    const disabledHours = [];
                    for (let i = 0; i < fromHour; i++) {
                        disabledHours.push(i);
                    }
                    return disabledHours;
                },
                disabledMinutes: (selectedHour) => {
                    if (selectedHour === fromHour) {
                        const disabledMinutes = [];
                        for (let i = 0; i < fromMinute; i++) {
                            disabledMinutes.push(i);
                        }
                        return disabledMinutes;
                    }
                    return [];
                }
            };
        }

        return {};
    };

    const generateMeetingLink = async (title, description, selectedDate, toDate, fromTime, toTime, list) => {
        if (selectedConferencing?.value === 'google') {
            return await createGoogleMeeting(title, description, selectedDate, toDate, fromTime, toTime, list);
        } else if (selectedConferencing?.value === 'zoom') {
            return await createZoomMeetings(title, description, list);
        } else {
            return;
        }
    }

    const createGoogleMeeting = async (title, description, selectedDate, toDate, fromTime, toTime, list) => {
        try {
            const fromdate = formatToMMDDYYYY(selectedDate)
            const toconverteddate = formatToMMDDYYYY(toDate)
            const fromDateTime = moment(`${fromdate} ${fromTime}`, "MM/DD/YYYY hh:mm A");
            const toDateTime = moment(`${toconverteddate} ${toTime}`, "MM/DD/YYYY hh:mm A");
            const UID = uuidv4()?.replace(/-/g, '')?.slice(0, 8)
            const recurrenceRule = generateRecurrenceRule(list);
            const eventDetails = {
                "user_name": user.name,
                "eventDetails": {
                    "summary": title,
                    "description": description,
                    "start": {
                        "dateTime": fromDateTime,
                        "timeZone": "UTC"
                    },
                    "end": {
                        "dateTime": toDateTime,
                        "timeZone": "UTC"
                    },
                    "conferenceData": {
                        "createRequest": {
                            "requestId": UID + new Date().getTime(),
                        }
                    },
                    "attendees": [
                        {
                            email: user?.name,
                            displayName: user?.name?.split('@')[0] || 'Organizer',
                            responseStatus: 'accepted'
                        }
                    ]
                }
            }
            if (recurrenceRule) {
                eventDetails.eventDetails.recurrence = [recurrenceRule];
            }
            const response = await createGoogleMeetEvent(eventDetails);
            if (response?.data) {
                setSelectedLocation({
                    value: response?.data?.hangoutLink,
                    label: response?.data?.hangoutLink,
                    lat: "",
                    lon: ""
                });
                return { meetingDetails: response?.data, description }
            }
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '-',
                message: `FileName: createEvents.js, Fun: startStatusCheck, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.log("Error on creating the Google Meeting")
        }
    }

    const createZoomMeetings = async (title, description, list) => {
        try {
            const response = await createZoomMeeting({
                topic: title || 'New Meeting',
                start_time: '',
                duration: 60,
                timezone: '',
                userName: [user?.name],
                type: 'event'
            });
            if (response?.data) {
                setSelectedLocation({
                    value: response?.data?.join_url,
                    label: response?.data?.join_url,
                    lat: "",
                    lon: ""
                });

                const userName = user?.name?.split('@')?.[0] || 'User';

                const meetingTemplate = `──────────
${userName} is inviting you to a scheduled Zoom meeting.
Join Zoom Meeting
${response?.data?.join_url}

Meeting ID: ${response?.data?.id}
Passcode: ${response?.data?.password}
──────────`;

                // Add the meeting template with proper spacing
                const newDescription = description
                    ? `${description?.trim()}\n\n${meetingTemplate}`
                    : meetingTemplate;

                setDescription(newDescription);
                return { meetingDetails: response?.data, description }
            }
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '-',
                message: `FileName: createEvents.js, Fun: createZoomMeetings, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error('Error creating Zoom meeting:', error);
        }
    };


    const handleRepeatStateChange = (newState) => {
        setRepeat(newState);
    };

    const handleCustomRepeatStateChange = (newState) => {
        setCustomRepeat(newState);
    };
    const handleTitle = (value) => {
        setTitle(value);
    }
    return (
        <>
            <Modal
                className="parent-div-content-event-preview"
                open={params.isOpen}
                closeIcon={null}
                footer={null}
            >
                <div className="event-container scrollable-60vh">
                    <div className="event-preview-header">
                        <span><span className="event-create-text">Create</span> <span className="event-cevent-text text-gradient">Event</span></span>
                        <div onClick={() => {
                            stopStatusCheck(); // Stop any ongoing status checks
                            params.close();
                        }} className="cursor-pointer">
                            {calender_svg.close_svg}
                        </div>
                    </div>

                    <div className="event-rendering-section">
                        <div>
                            <input
                                className="event-input"
                                placeholder="Add Title"
                                value={title}
                                onChange={(e) => handleTitle(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="event-date-picker-cover flex mt-3 gap-20">
                        <div className="width-60">
                            <div className="event-date-picker-section">
                                <CalendarIcon />
                                <Popover
                                    content={
                                        <div className="d-flex">
                                            <DayPicker
                                                mode="single"
                                                selected={selectedDate.toDate()}
                                                onSelect={(date) => handleDateChange(date, "from")}
                                                disabled={disabledDates}
                                            />
                                        </div>
                                    }
                                    trigger="click"
                                    open={popoverVisibleFrom}
                                    onOpenChange={(open) => setPopoverVisibleFrom(open)}
                                    placement="bottomLeft"
                                >
                                    <div className="d-flex gap-3">
                                        {/* From Field */}
                                        <span
                                            onClick={() => handlePopoverOpen("from")}
                                            className="cursor-pointer flex align-items-center gap-2"
                                        >
                                            <span
                                                className="text-bold-dark"
                                            >
                                                From:{" "}
                                                <span
                                                    className="text-normal-gray"
                                                >
                                                    {selectedDate.format("MMMM Do, YYYY")}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </Popover>
                                {visible && selectedDate && (
                                    <>
                                        {!isCheck && (
                                            <div className="flex justify-center">
                                                <div className="mr-2 mr-5px">
                                                    <Space wrap>
                                                        <TimePicker
                                                            ref={timePicker}
                                                            needConfirm={false}
                                                            showOK={false}
                                                            format="hh:mm A"
                                                            use12Hours
                                                            onChange={handleFromTimeChange}
                                                            allowClear={false}
                                                            value={dayjs(fromTime, "hh:mm A")}
                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                            size="large"
                                                        />
                                                    </Space>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                <Popover
                                    content={
                                        <div className="d-flex">
                                            <DayPicker
                                                mode="single"
                                                selected={toDate.toDate()}
                                                onSelect={(date) => handleDateChange(date, "to")}
                                                disabled={disabledDates}
                                            />
                                        </div>
                                    }
                                    trigger="click"
                                    open={popoverVisibleTo}
                                    onOpenChange={(open) => setPopoverVisibleTo(open)}
                                    placement="bottomRight"
                                >
                                    <div className="d-flex gap-3">
                                        {/* To Field */}
                                        <span
                                            onClick={() => handlePopoverOpen("to")}
                                            className="cursor-pointer flex align-items-center gap-2"
                                        >
                                            <span
                                                className="text-bold-dark"
                                            >
                                                To:{" "}
                                                <span
                                                    className="text-normal-gray"
                                                >
                                                    {toDate.format("MMMM Do, YYYY")}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </Popover>
                                {visible && selectedDate ? (
                                    <>
                                        {!isCheck && (
                                            <div className="flex justify-center">

                                                <div>
                                                    <Space wrap>
                                                        <TimePicker
                                                            ref={timePickerRef}
                                                            popupClassName="time-picker-dropdown"
                                                            needConfirm={false}
                                                            showOK={false}
                                                            format="hh:mm A"
                                                            use12Hours
                                                            onChange={handleToTimeChange}
                                                            value={dayjs(toTime, "hh:mm A")}
                                                            disabledTime={disabledTime}
                                                            allowClear={false}
                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                            size="large"
                                                        />
                                                    </Space>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    selectedDate && (
                                        <div>
                                            <button
                                                onClick={handletimevisible}
                                                className="buttoncss"
                                            >
                                                Add Time
                                            </button>
                                        </div>
                                    )
                                )}
                            </div>
                            {visible && (
                                <div className="mt-3 mb-3 ml-25px">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={isCheck}
                                            onChange={handleCheckboxChange}
                                        />
                                        <span className="ml-[5px] pb-[5px] ms-5px" >All Day</span>
                                    </label>
                                </div>
                            )}
                            <RepeatEvent onRepeatStateChange={handleRepeatStateChange} onCustomRepeatStateChange={handleCustomRepeatStateChange} fromDate={selectedDate} />
                            <div className="event-add-guest-section">
                                <div className="guest-input-section">
                                    <img src="/app/guest.png" className="mr-1" alt="addguest" width={18} height={18} />
                                    <input placeholder="Add guest" value={guestText} onChange={(e) => handleGuestInputChange(e.target.value)} />
                                </div>
                                {suggestions && suggestions.length > 0 && (
                                    <div className="guest-drop overflow-auto">
                                        {suggestions.length > 0 &&
                                            suggestions.map((contact, index) => (
                                                <div
                                                    className="flex align-items-center gap-2 cursor-pointer"
                                                    key={index}
                                                    onClick={() => {
                                                        handleGuest(contact);
                                                    }}
                                                >
                                                    <button className="guestlogo">
                                                        {contact[0].toUpperCase()}
                                                    </button>

                                                    <span>{contact}</span>
                                                </div>
                                            ))}
                                    </div>
                                )}
                                <div className="flex flex-column mt-2 ps-4 gap-2 guest-list-section max-h-15rem overflow-auto">
                                    {guestList.map((value, index) => (
                                        <div key={index} className="flex align-items-center justify-content-between gap-2">
                                            <span>{value}</span>
                                            <button
                                                className="border-0 bg-transparent d-flex"
                                                onClick={(e) => handledelete(index, e)}
                                            >
                                                {calender_svg.close_svg}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={meetingAppConnectStatus ? "meeting-type-buttons" : "d-none"}>
                                <button
                                    key={'inperson'}
                                    className={`meeting-type-btn ${selectedConferencing?.value === 'inperson' ? 'selected' : ''}`}
                                    onClick={() => setSelectedConferencing({
                                        value: 'inperson',
                                        label: 'In-person',
                                        icon: <MapPinCheck width={18} />
                                    })}
                                >
                                    <MapPinCheck width={18} /> In-person
                                </button>
                                <button
                                    key={'zoom'}
                                    className={`meeting-type-btn ${selectedConferencing?.value === 'zoom' ? (meetingAppConnectStatus?.isZoomConnected ? 'selected' : 'selected warning') : ''}`}
                                    onClick={() => {
                                        if (meetingAppConnectStatus?.isZoomConnected) {
                                            setSelectedConferencing({
                                                value: 'zoom',
                                                label: 'Zoom',
                                                icon: <img src="/app/zoom.svg" alt="Zoom" width={18} />
                                            });
                                        } else {
                                            // If not connected, select it anyway to show the error message
                                            setSelectedConferencing({
                                                value: 'zoom',
                                                label: 'Zoom',
                                                icon: <img src="/app/zoom.svg" alt="Zoom" width={18} />
                                            });
                                            startStatusCheck('zoom'); // Start checking for Zoom connection
                                        }
                                    }}
                                >
                                    <img src="/app/zoom.svg" alt="Zoom" width={18} /> Zoom
                                </button>
                                <button
                                    key={'google'}
                                    className={`meeting-type-btn ${selectedConferencing?.value === 'google' ? (meetingAppConnectStatus?.isGoogleConnected ? 'selected' : 'selected warning') : ''}`}
                                    onClick={() => {
                                        if (meetingAppConnectStatus?.isGoogleConnected) {
                                            setSelectedConferencing({
                                                value: 'google',
                                                label: 'Google Meet',
                                                icon: <img src="/app/google-meet.png" alt="Google Meet" width={25} />
                                            });
                                        } else {
                                            // If not connected, select it anyway to show the error message
                                            setSelectedConferencing({
                                                value: 'google',
                                                label: 'Google Meet',
                                                icon: <img src="/app/google-meet.png" alt="Google Meet" width={25} />
                                            });
                                            startStatusCheck('google'); // Start checking for Google Meet connection
                                        }
                                    }}
                                >
                                    <img src="/app/google-meet.png" alt="Google Meet" width={25} /> Google Meet
                                </button>
                            </div>

                            {/* Error messages for disconnected accounts */}
                            {selectedConferencing?.value === 'zoom' && !meetingAppConnectStatus?.isZoomConnected && (
                                <div className="meeting-error-alert">
                                    <div className="meeting-error-content">
                                        <span className="meeting-error-icon">⚠️</span>
                                        <span className="meeting-error-text">Your Zoom account is not connected</span>
                                    </div>
                                    <div className="meeting-error-actions">
                                        <button
                                            className="connect-btn"
                                            onClick={() => {
                                                window.open(config.DCALENDAR_URL + '/settings/integrations?app=dmail', '_blank');
                                            }}
                                        >
                                            Connect Zoom <span className="font-10px">↗</span>
                                        </button>
                                        <button
                                            className="close-error-btn"
                                            onClick={() => {
                                                setSelectedConferencing(null);
                                                stopStatusCheck(); // Stop checking for connection status
                                            }}
                                        >
                                            <X size={16} />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {selectedConferencing?.value === 'google' && !meetingAppConnectStatus?.isGoogleConnected && (
                                <div className="meeting-error-alert">
                                    <div className="meeting-error-content">
                                        <span className="meeting-error-icon">⚠️</span>
                                        <span className="meeting-error-text">Your Google Meet account is not connected</span>
                                    </div>
                                    <div className="meeting-error-actions">
                                        <button
                                            className="connect-btn"
                                            onClick={() => {
                                                // Add your Google Meet connection logic here
                                                window.open(config.DCALENDAR_URL + '/settings/integrations?app=dmail', '_blank');
                                            }}
                                        >
                                            Connect Google Meet <span className="font-10px">↗</span>
                                        </button>
                                        <button
                                            className="close-error-btn"
                                            onClick={() => {
                                                setSelectedConferencing(null);
                                                stopStatusCheck(); // Stop checking for connection status
                                            }}
                                        >
                                            <X size={16} />
                                        </button>
                                    </div>
                                </div>
                            )}
                            {(selectedConferencing?.value && (selectedConferencing?.value === 'inperson' || (selectedConferencing?.value === 'google' && meetingAppConnectStatus?.isGoogleConnected) || (selectedConferencing?.value === 'zoom' && meetingAppConnectStatus?.isZoomConnected))) && (
                                <div className="selected-conferencing-pill mb-2 d-flex align-items-center inline-flex-pill">
                                    {selectedConferencing.icon}
                                    <span className="ml-4px">{selectedConferencing.label}</span>
                                    <button
                                        className="btn text-black px-2 py-2 create-event-btn-transparent"
                                        onClick={() => {
                                            setSelectedConferencing(null);
                                            stopStatusCheck(); // Stop checking for connection status
                                        }}
                                    >
                                        <X size={15} />
                                    </button>
                                    {(selectedConferencing?.value === 'google' || selectedConferencing?.value === 'zoom') ?
                                        <span className="ml-2 create-event-text-12px-gray">
                                            Conferencing details provided after booking completion.
                                        </span>
                                        :
                                        <Select
                                            value={selectedLocation}
                                            onInputChange={handleInputChange}
                                            onChange={handleLocationSelect}
                                            options={locations}
                                            className="location-select-inperson"
                                            placeholder="Pick a location"
                                            isClearable
                                            components={{
                                                DropdownIndicator: () => null
                                            }}
                                            style={{ width: '70%' }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    border: "none",
                                                    boxShadow: "none",
                                                    "&:hover": {
                                                        border: "none"
                                                    },
                                                    maxWidth: "400px",
                                                    width: "100%"
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    border: "none"
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    overflow: "auto"
                                                }),
                                            }} />
                                    }
                                </div>
                            )}

                            <div className={selectedConferencing?.value ? "d-none" : "event-add-location-section mt-3 mb-3"}>
                                <MapPinCheck />
                                <Select
                                    value={selectedLocation}
                                    onInputChange={handleInputChange}
                                    onChange={handleLocationSelect}
                                    options={locations}
                                    className="location-select"
                                    placeholder="Pick a location"
                                    isClearable
                                    components={{
                                        DropdownIndicator: () => null
                                    }}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "none",
                                            boxShadow: "none",
                                            "&:hover": {
                                                border: "none"
                                            },
                                            width: "200px"
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            border: "none"
                                        }),
                                        option: (base) => ({
                                            ...base,
                                            overflow: "auto"
                                        })
                                    }} />
                            </div>
                            <div className="event-description-section">
                                <textarea className="event-textarea" value={description} onChange={(e) => {
                                    setDescription(e.target.value);
                                }} placeholder="Add description" />
                            </div>
                        </div>
                        <div className='slot-calendar'>
                            <SlotCalendar fromDate={selectedDate} toDate={toDate} setFromDate={setSelectedDate} setToDate={setToDate} setFromTime={setFromTime} setVisible={setVisible} setToTime={setToTime} setChecked={setChecked} fromTime={fromTime} toTime={toTime} guestList={guestList} />
                        </div>
                    </div>
                </div>

                <div className="event-create-button-section pt-2">
                    <button className="event-create-button" onClick={() => {
                        stopStatusCheck(); // Stop any ongoing status checks
                        createEvent();
                    }}>Create Event</button>
                </div>

            </Modal >
            {
                loader &&
                <CompleteLoader isOpen={loader} text={text} />
            }
        </>
    );
}